import { Component, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { NotificationsService } from '../../notifications.service';
import { PreferencesService, NewsTickerSpeed } from '../../services/preferences.service';

@Component({
  selector: 'app-preferences-bottom-sheet',
  templateUrl: './preferences-bottom-sheet.component.html',
  styleUrls: ['./preferences-bottom-sheet.component.scss']
})
export class PreferencesBottomSheetComponent {
  NewsTickerSpeed = NewsTickerSpeed;
  currentTickerSpeed: NewsTickerSpeed;

  constructor(
    private bottomSheetRef: MatBottomSheetRef<PreferencesBottomSheetComponent>,
    public notificationsService: NotificationsService,
    public preferencesService: PreferencesService,
    private snackBar: MatSnackBar
  ) {
    this.currentTickerSpeed = this.preferencesService.getNewsTickerSpeed();
  }

  showTooltip(tooltip: any) {
    tooltip.show();
    setTimeout(() => tooltip.hide(), 3000);
  }

  onTickerSpeedChange(speed: NewsTickerSpeed) {
    this.currentTickerSpeed = speed;
    this.preferencesService.setNewsTickerSpeed(speed);
  }

  async changeNotificationsReceive() {
    await this.notificationsService.changeNotificationsReceive();
  }

  activating = false;

  async subscribeToNotifications() {
    if (this.activating) return;
    this.activating = true;
    try {
      const { ok, message } = await this.notificationsService.activateNotifications();
      this.snackBar.open(message, 'OK', { duration: ok ? 4000 : 12000 });
    } catch {
      this.snackBar.open('Activation impossible pour le moment, réessayez plus tard.', 'OK', { duration: 6000 });
    } finally {
      this.activating = false;
    }
  }

  isSubscribedToNotifications(): boolean {
    return this.notificationsService.isSubscribedToNotifications();
  }

  atLeastOneNotificationChecked(): boolean {
    return this.notificationsService.atLeastOneNotificationChecked();
  }

  close() {
    this.bottomSheetRef.dismiss();
  }
}
